module.exports = __webpack_public_path__ + "static/media/universities-icon-2.b5a0bac8.svg";